import React, { useState } from 'react';
import './UserManager.css';
import { useGlobalState } from 'hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

export function UserManager() {
    const [state, dispatch] = useGlobalState();
    const [show, setShow] = useState(false);

    return (
        <div className="user_manager_main_cont">
            <div className="blue_top_bar user_info_line_bold">
                <FontAwesomeIcon icon={faUser} />
                &nbsp;
                {state.selectedUser.username !== null ? state.selectedUser.username : ''}
            </div>
            {state.selectedUser.username !== null && (
                <div className="file_manager_file_info_cont">
                    <div className="user_info_line user_info_line_bold user_info_line_left_align">
                        Company:
                    </div>
                    <div className="user_info_line user_info_line_left_align">
                        {state.selectedUser.company}
                    </div>
                    <div className="user_info_line user_info_line_bold user_info_line_left_align">
                        Email address:
                    </div>
                    <div className="user_info_line user_info_line_left_align">
                        {state.selectedUser.email}
                    </div>
                    <div className="user_info_line user_info_line_bold user_info_line_left_align">
                        Phone number:
                    </div>
                    <div className="user_info_line user_info_line_left_align">
                        {state.selectedUser.phone}
                    </div>
                </div>
            )}
        </div>
    );
}
